export enum SeasonPriceModeEnum {
  TAG_PRICE = 'TAG_PRICE',
  TOTAl = 'TOTAL',
}
